import Modal from "src/components/common/modal";
import {
    onlyUnique
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function FilterForm({
    closeIt, setCurrentPage,
    curFilter, setFilter, usersList, usersListMap,
    purchaseList,
    paymentMethodsData = { paymentMethods: [], types: [] },
    defaultFilter
}){
    return (
        <Modal
            touchOutsideClose = {true}
            closeIt = {closeIt}
            title = "Filter"
            width = {"60%"}
        >
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Validity:</span>
                <select className = "form-control inline" value = {curFilter.void} onChange = {e => setFilter({...curFilter, void: e.currentTarget.value})}>
                    <option value = "">Valid</option>
                    <option value = "yes">Void</option>
                    <option>All</option>
                </select>
                {
                curFilter.void?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, void: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3 row">
                <span className = "mr-3 font-weight-bold" style = {{alignSelf: "center"}}>Created By:</span>
                <select className = "form-control" onChange = {e => setFilter({...curFilter, createdBy: e.currentTarget.value})} value = {curFilter.createdBy}>
                    <option value = "">Select</option>
                    {purchaseList.map(purchase => purchase.submitterEmail).filter(onlyUnique).map((submitterEmail, submitterEmailIndex) => 
                    <option key = {submitterEmailIndex} value = {submitterEmail}>
                        {usersListMap[submitterEmail]?.label}
                    </option>)}
                </select>
                {
                curFilter.createdBy?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, createdBy: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Submit Time:</span>
                <span className = "mr-3">min:</span>
                <input
                    type = "date"
                    min = "1900-01-01"
                    max = "2999-12-31"
                    className = "mr-3 form-control"
                    value = {curFilter.submitTimeMin}
                    onChange = {e => {
                        setFilter({...curFilter, submitTimeMin: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                <span className = "mr-3">max:</span>
                <input
                    type = "date"
                    min = "1900-01-01"
                    max = "2999-12-31"
                    className = "form-control"
                    value = {curFilter.submitTimeMax}
                    onChange = {e => {
                        setFilter({...curFilter, submitTimeMax: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                {
                curFilter.submitTimeMax || curFilter.submitTimeMin?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, submitTimeMin: "", submitTimeMax: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3 row">
                <span className = "mr-3 font-weight-bold" style = {{alignSelf: "center"}}>Updated By:</span>
                <select className = "form-control" value = {curFilter.updatedBy} onChange = {e => setFilter({...curFilter, updatedBy: e.currentTarget.value})}>
                    <option value = "">Select</option>
                    {purchaseList.map(purchase => purchase.updaterEmail).filter(onlyUnique).map((updaterEmail, updaterEmailIndex) => 
                    <option key = {updaterEmailIndex} value = {updaterEmail}>
                        {usersListMap[updaterEmail]?.label}
                    </option>)}
                </select>
                {
                curFilter.updatedBy?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, updatedBy: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Date Updated:</span>
                <span className = "mr-3">min:</span>
                <input
                    type = "date"
                    min = "1900-01-01"
                    max = "2999-12-31"
                    className = "mr-3 form-control"
                    value = {curFilter.dateUpdatedMin}
                    onChange = {e => {
                        setFilter({...curFilter, dateUpdatedMin: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                <span className = "mr-3">max:</span>
                <input
                    type = "date"
                    min = "1900-01-01"
                    max = "2999-12-31"
                    className = "form-control"
                    value = {curFilter.dateUpdatedMax}
                    onChange = {e => {
                        setFilter({...curFilter, dateUpdatedMax: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                {
                curFilter.dateUpdatedMax || curFilter.dateUpdatedMin?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, dateUpdatedMin: "", dateUpdatedMax: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3 row">
                <span className = "mr-3 font-weight-bold" style = {{alignSelf: "center"}}>Requested By:</span>
                <select className = "form-control" value = {curFilter.requestedBy} onChange = {e => setFilter({...curFilter, requestedBy: e.currentTarget.value})}>
                    <option value = "">Select</option>
                    {purchaseList.map(purchase => purchase.requestorEmail).filter(onlyUnique).map((requestorEmail, requestorEmailIndex) => 
                    <option key = {requestorEmailIndex} value = {requestorEmail}>
                        {usersListMap[requestorEmail]?.label}
                    </option>)}
                </select>
                {
                curFilter.requestedBy?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, requestedBy: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">PO Date:</span>
                <span className = "mr-3">min:</span>
                <input
                    type = "date"
                    min = "1900-01-01"
                    max = "2999-12-31"
                    className = "mr-3 form-control"
                    value = {curFilter.poDateMin}
                    onChange = {e => {
                        setFilter({...curFilter, poDateMin: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                <span className = "mr-3">max:</span>
                <input
                    type = "date"
                    min = "1900-01-01"
                    max = "2999-12-31"
                    className = "form-control"
                    value = {curFilter.poDateMax}
                    onChange = {e => {
                        setFilter({...curFilter, poDateMax: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                {
                curFilter.poDateMax || curFilter.poDateMin?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, poDateMin: "", poDateMax: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Payment Method:</span>
                <select className = "form-control inline" value = {curFilter.paymentMethod} onChange = {e => setFilter({...curFilter, paymentMethod: e.currentTarget.value})}>
                    <option value = "">Select</option>
                    {paymentMethodsData.types.map((paymentMethod, paymentMethodIndex) => <option key = {paymentMethodIndex}>{paymentMethod}</option>)}
                </select>
                {
                curFilter.paymentMethod?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, paymentMethod: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Billable:</span>
                <select className = "form-control inline" value = {curFilter.billable} onChange = {e => {
                    setFilter({...curFilter, billable: e.currentTarget.value});
                    setCurrentPage(1);
                }}>
                    <option value = "">Select</option>
                    <option>Yes</option>
                    <option>No</option>
                </select>
                {curFilter.billable === "No"?<>
                <span className = "m-3 font-weight-bold">Included In Proposal:</span>
                <select className = "form-control inline" value = {curFilter.includedInProposal} onChange = {e => {
                    setFilter({...curFilter, includedInProposal: e.currentTarget.value});
                    setCurrentPage(1);
                }}>
                    <option value = "">Select</option>
                    <option>Yes</option>
                    <option>No</option>
                </select>
                </>:null}
                {
                curFilter.billable?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, billable: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Total:</span>
                <span className = "mr-3">min:</span>
                <input value = {curFilter.totalMin} onChange = {e => {
                    setFilter({...curFilter, totalMin: e.currentTarget.value});
                    setCurrentPage(1);
                }} type = "number" step = "any" className = "mr-3 form-control inline"/>
                <span className = "mr-3">max:</span>
                <input value = {curFilter.totalMax} onChange = {e => {
                    setFilter({...curFilter, totalMax: e.currentTarget.value});
                    setCurrentPage(1);
                }} type = "number" step = "any" className = "form-control inline"/>
                {
                curFilter.totalMax || curFilter.totalMin?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, totalMin: "", totalMax: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Approver:</span>
                <select className = "form-control inline" value = {curFilter.approver} onChange = {e => {
                    setFilter({...curFilter, approver: e.currentTarget.value.toLowerCase()});
                    setCurrentPage(1);
                }}>
                    <option value = "">Select</option>
                    {usersList.filter(user => user.purchases === "approver").map((user, userIndex) => 
                    <option key = {userIndex} value = {user.value}>
                        {user.label}
                    </option>)}
                </select>
                {
                curFilter.approver !== ""?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, approver: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Project Name:</span>
                <input type = "text" className = "form-control inline" value = {curFilter.projectName} onChange = {e => {
                    setFilter({...curFilter, projectName: e.currentTarget.value.toLowerCase()});
                    setCurrentPage(1);
                }}/>
                {
                curFilter.projectName !== ""?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, projectName: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Notes:</span>
                <input type = "text" className = "form-control inline" value = {curFilter.notes} onChange = {e => {
                    setFilter({...curFilter, notes: e.currentTarget.value});
                    setCurrentPage(1);
                }}/>
                {
                curFilter.notes !== ""?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, notes: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Billable:</span>
                <select className = "form-control inline" value = {curFilter.billable} onChange = {e => {
                    setFilter({...curFilter, billable: e.currentTarget.value});
                    setCurrentPage(1);
                }}>
                    <option value = "">Select</option>
                    <option>Yes</option>
                    <option>No</option>
                </select>
                {curFilter.billable === "No"?<>
                <span className = "m-3 font-weight-bold">Included In Proposal:</span>
                <select className = "form-control inline" value = {curFilter.includedInProposal} onChange = {e => {
                    setFilter({...curFilter, includedInProposal: e.currentTarget.value});
                    setCurrentPage(1);
                }}>
                    <option value = "">Select</option>
                    <option>Yes</option>
                    <option>No</option>
                </select>
                </>:null}
                {
                curFilter.billable?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, billable: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Paid:</span>
                <select className = "form-control inline" value = {curFilter.paid} onChange = {e => {
                    setFilter({...curFilter, paid: e.currentTarget.value});
                    setCurrentPage(1);
                }}>
                    <option value = "All">Select</option>
                    <option value = "yes">Yes</option>
                    <option value = "">No</option>
                </select>
                {
                curFilter.paid !== "All"?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, paid: "All"})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Billed:</span>
                <select className = "form-control inline" value = {curFilter.billed} onChange = {e => {
                    setFilter({...curFilter, billed: e.currentTarget.value});
                    setCurrentPage(1);
                }}>
                    <option value = "All">Select</option>
                    <option value = "yes">Yes</option>
                    <option value = "">No</option>
                </select>
                {
                curFilter.billed !== "All"?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, billed: "All"})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Status:</span>
                <select className = "form-control inline" value = {curFilter.status} onChange = {e => {
                    setFilter({...curFilter, status: e.currentTarget.value});
                    setCurrentPage(1);
                }}>
                    <option value = "All">Select</option>
                    <option>Approved</option>
                    <option>Rejected</option>
                    <option value = "">Pending</option>
                </select>
                {
                curFilter.status !== "All"?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, status: "All"})}}>❌</span>:
                null
                }
            </div>
            <div className = "mt-5 mb-3">
                <span className = "btn btn-secondary" onClick = {() => {
                    setFilter(defaultFilter);
                    setCurrentPage(1);
                }}>Clear Filter</span>
            </div>
        </Modal>
    )
}